var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 100 60",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns",
        width: "100%",
        height: "100%",
      },
    },
    [
      _c("defs", [
        _c("rect", {
          attrs: {
            id: "path-1",
            x: "0",
            y: "0",
            width: "100",
            height: "60",
            rx: "4",
          },
        }),
        _c("path", {
          attrs: {
            id: "path-3",
            d: "M24.1154168,60 L96.0003648,60 C98.2093023,60 100,58.2128397 100,56.0053027 L100,33.6980686 C100,33.6980686 73.1995341,51.8679968 24.1154168,60 Z",
          },
        }),
      ]),
      _c(
        "g",
        {
          attrs: {
            id: "Icons:-Credit-card",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "sketch:type": "MSPage",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Discover-card-light",
                "sketch:type": "MSArtboardGroup",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Credit-Card/Discover/Discover-card-light",
                    "sketch:type": "MSLayerGroup",
                  },
                },
                [
                  _c("g", { attrs: { id: "Rectangle" } }, [
                    _c(
                      "mask",
                      {
                        attrs: {
                          id: "mask-2",
                          "sketch:name": "Mask",
                          fill: "white",
                        },
                      },
                      [_c("use", { attrs: { "xlink:href": "#path-1" } })]
                    ),
                    _c("use", {
                      attrs: {
                        id: "Mask",
                        fill: "#FFFFFF",
                        "sketch:type": "MSShapeGroup",
                        "xlink:href": "#path-1",
                      },
                    }),
                    _c(
                      "mask",
                      {
                        attrs: {
                          id: "mask-4",
                          "sketch:name": "Mask",
                          fill: "white",
                        },
                      },
                      [_c("use", { attrs: { "xlink:href": "#path-3" } })]
                    ),
                    _c("use", {
                      attrs: {
                        id: "Mask",
                        fill: "#E7772F",
                        "sketch:type": "MSShapeGroup",
                        "xlink:href": "#path-3",
                      },
                    }),
                  ]),
                  _c("path", {
                    attrs: {
                      d: "M18.2885834,29.8220151 C17.5378699,30.4639095 16.5822027,30.7445978 15.0539813,30.7445978 L14.419847,30.7445978 L14.419847,23.084597 L15.0539813,23.084597 C16.5822027,23.084597 17.5012039,23.3463928 18.2885834,24.0202246 C19.1013471,24.7165474 19.5897574,25.7907198 19.5897574,26.9017775 C19.5897574,28.0182331 19.1013471,29.1306403 18.2885834,29.8220151 L18.2885834,29.8220151 Z M15.5273492,21.1224781 L12.0577084,21.1224781 L12.0577084,32.7076164 L15.5061957,32.7076164 C17.3413776,32.7076164 18.6660555,32.2897327 19.8271465,31.3675998 C21.2063534,30.2754346 22.024758,28.626391 22.024758,26.9179711 C22.024758,23.4979825 19.3547188,21.1224781 15.5273492,21.1224781 L15.5273492,21.1224781 Z",
                      id: "Fill-13",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M23.1139272,21.1224781 L25.4666642,21.1224781 L25.4666642,32.7076164 L23.1139272,32.7076164 L23.1139272,21.1224781 Z",
                      id: "Fill-14",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M31.2443847,25.5626606 C29.824281,25.064259 29.4092028,24.7322911 29.4092028,24.1061404 C29.4092028,23.3783301 30.1509848,22.8263998 31.1710526,22.8263998 C31.8780489,22.8263998 32.4604747,23.097192 33.0809768,23.7588786 L34.3092888,22.2168925 C33.2943919,21.3622327 32.0797121,20.9295049 30.7555042,20.9295049 C28.6128918,20.9295049 26.9798431,22.3558871 26.9798431,24.2419863 C26.9798431,25.8433489 27.739018,26.6557255 29.9544925,27.4271684 C30.8805448,27.7352957 31.3510922,27.9458119 31.5894214,28.0884052 C32.0613791,28.380339 32.2964177,28.7986724 32.2964177,29.2822299 C32.2964177,30.2246048 31.5160894,30.9173291 30.4612358,30.9173291 C29.3382211,30.9173291 28.4295616,30.3793432 27.8856821,29.3690454 L26.3635718,30.7796838 C27.4518008,32.3054765 28.7562654,32.987405 30.553371,32.987405 C33.0043542,32.987405 34.7314183,31.4170801 34.7314183,29.1805704 C34.7314183,27.337654 33.9304065,26.5023365 31.2443847,25.5626606",
                      id: "Fill-15",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M35.4732003,26.9179711 C35.4732003,30.3249149 38.26781,32.964914 41.8653118,32.964914 C42.8797387,32.964914 43.7493818,32.7732902 44.8202179,32.2897327 L44.8202179,29.6272426 C43.8739523,30.5372304 43.0433256,30.8961875 41.9687288,30.8961875 C39.5915478,30.8961875 37.9077308,29.2502927 37.9077308,26.9017775 C37.9077308,24.6828108 39.6460768,22.9249106 41.8653118,22.9249106 C42.985036,22.9249106 43.8405768,23.3045595 44.8202179,24.2280419 L44.8202179,21.5687005 C43.7855777,21.0680498 42.9366181,20.8606823 41.9137298,20.8606823 C38.3369114,20.8606823 35.4732003,23.5524108 35.4732003,26.9179711",
                      id: "Fill-16",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M63.9486046,28.900332 L60.7201135,21.1224781 L58.14597,21.1224781 L63.2782743,33 L64.5441926,33 L69.7761532,21.1224781 L67.2222231,21.1224781 L63.9486046,28.900332",
                      id: "Fill-17",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M70.8474595,32.7076164 L77.5427709,32.7076164 L77.5427709,30.7445978 L73.209598,30.7445978 L73.209598,27.6174426 L77.3782438,27.6174426 L77.3782438,25.6548739 L73.209598,25.6548739 L73.209598,23.084597 L77.5427709,23.084597 L77.5427709,21.1224781 L70.8474595,21.1224781 L70.8474595,32.7076164",
                      id: "Fill-18",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M82.1542294,26.4497075 L81.4688567,26.4497075 L81.4688567,22.9456024 L82.1927758,22.9456024 C83.6678784,22.9456024 84.4580784,23.5380166 84.4580784,24.6666173 C84.4580784,25.8262557 83.6678784,26.4497075 82.1542294,26.4497075 L82.1542294,26.4497075 Z M86.8893184,24.5406674 C86.8893184,22.371181 85.3343026,21.1224781 82.6083241,21.1224781 L79.1015473,21.1224781 L79.1015473,32.7076164 L81.4688567,32.7076164 L81.4688567,28.0497206 L81.7758172,28.0497206 L85.0376838,32.7076164 L87.9422916,32.7076164 L84.133255,27.8248101 C85.9134378,27.4766487 86.8893184,26.3134117 86.8893184,24.5406674 L86.8893184,24.5406674 Z",
                      id: "Fill-19",
                      fill: "#1A1918",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M58.4787848,26.9449603 C58.4787848,30.2803826 55.6545602,32.9838064 52.1675266,32.9838064 C48.6814331,32.9838064 45.8567384,30.2803826 45.8567384,26.9449603 C45.8567384,23.6090883 48.6814331,20.9052146 52.1675266,20.9052146 C55.6545602,20.9052146 58.4787848,23.6090883 58.4787848,26.9449603",
                      id: "Fill-20",
                      fill: "#E7772F",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }